export const SearchIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20">
      <path
        d="m15.479 17.146-4.458-4.438q-.688.459-1.479.698-.792.24-1.688.24-2.375 0-4.052-1.656-1.677-1.657-1.677-4.032t1.677-4.052q1.677-1.677 4.052-1.677 2.396 0 4.042 1.677t1.646 4.052q0 .896-.219 1.677-.219.782-.719 1.427l4.479 4.521q.334.334.323.792-.01.458-.344.771-.312.333-.781.333-.469 0-.802-.333Zm-7.625-5.792q1.417 0 2.406-.989.99-.99.99-2.407 0-1.437-.979-2.437-.979-1-2.417-1-1.416 0-2.427 1-1.01 1-1.01 2.437 0 1.438 1.01 2.417 1.011.979 2.427.979Z"
        fill="#919EAB"
      />
    </svg>
  );
};
